// Import all images
import logo from '../assets/images/logo/splashbg.png';
import footerLogo from '../assets/images/logo/splashbg-1.png';
import clientLogo from '../assets/images/clients/logo.png';

// Banner images
import makeInIndia from '../assets/images/banners/make-in-india.png';
import madeInIndia from '../assets/images/banners/made-in-india.png';
import eWayBill from '../assets/images/banners/e-way-bill.png';
import hospitalSolutions from '../assets/images/banners/invoice.jpg';
import gstReturns from '../assets/images/banners/gst-returns.png';

// About image
import aboutUs from '../assets/images/about/about-us.jpg';

// Product images
import generalTrading from '../assets/images/products/general-trading.jpg';
import superMarket from '../assets/images/products/super-market-services.jpg';
import textiles from '../assets/images/products/textiles.jpg';
import pharmacy from '../assets/images/products/pharmacy.jpg';
import labourManagement from '../assets/images/products/labour-management.jpg';
import hospitalSolution from '../assets/images/products/hospital-solutions.jpg';
import creditManagement from '../assets/images/products/management.jpg';
import labSolutions from '../assets/images/products/lab-solutions.jpg';
import bakerySolutions from '../assets/images/products/bakery-solutions.jpg';
import opticalTraders from '../assets/images/products/optical-traders.jpg';
import productionManagement from '../assets/images/products/production-management.jpg';
import onlineOffline from '../assets/images/products/online-and-offline.jpg';
import mobileApps from '../assets/images/products/mobile-apps.jpg';
import insuranceAgent from '../assets/images/products/insurance-agent-solutions.jpg';

// Testimonial image
import testimonial from '../assets/images/testimonials/testimonial.png';

// Icon images
import facebookIcon from '../assets/images/icons/facebook.svg';
import instagramIcon from '../assets/images/icons/instagram.svg';
import linkedinIcon from '../assets/images/icons/linkedin.svg';
import twitterIcon from '../assets/images/icons/twitter.svg';
import youtubeIcon from '../assets/images/icons/youtube.svg';
import arrowWhiteLeft from '../assets/images/icons/arrow-white-left.svg';
import arrowWhiteRight from '../assets/images/icons/arrow-white-right.svg';
import arrowLeft from '../assets/images/icons/arrow-left.svg';
import arrowRight from '../assets/images/icons/arrow-right.svg';
import mouseWheel from '../assets/images/icons/mouse-weel.svg';
import closeIcon from '../assets/images/icons/close.svg';

// Export all image paths
export const images = {
    logo,
    footerLogo,
    clientLogo,

    banners: {
        makeInIndia,
        madeInIndia,
        eWayBill,
        hospitalSolutions,
        gstReturns,
    },

    aboutUs,

    products: {
        generalTrading,
        superMarket,
        textiles,
        pharmacy,
        labourManagement,
        hospitalSolution,
        creditManagement,
        labSolutions,
        bakerySolutions,
        opticalTraders,
        productionManagement,
        onlineOffline,
        mobileApps,
        insuranceAgent,
    },

    testimonial,

    icons: {
        facebook: facebookIcon,
        instagram: instagramIcon,
        linkedin: linkedinIcon,
        twitter: twitterIcon,
        youtube: youtubeIcon,
        arrowWhiteLeft: arrowWhiteLeft || arrowLeft,   // ✅ fixed: no self-reference
        arrowWhiteRight: arrowWhiteRight || arrowRight,  // ✅ fixed: no self-reference
        arrowLeft,
        arrowRight,
        mouseWheel: mouseWheel,                     // ✅ fixed: no self-reference
        close: closeIcon,
    },
};